var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 21,
    viewBox: "0 0 22.5 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.99978,
    y: 0.99952,
    width: 7,
    height: 7,
    fill: "transparent",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8,9H1c-.55225,0-1-.44727-1-1V1C0,.44727.44775,0,1,0h7c.55225,0,1,.44727,1,1v7c0,.55273-.44775,1-1,1Zm-6-2h5V2H2v5Z",
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 0.5,
    width: 11,
    height: 2,
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 3.5,
    width: 11,
    height: 2,
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 6.5,
    width: 6,
    height: 2,
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.99978,
    y: 12.99952,
    width: 7,
    height: 7,
    fill: "transparent",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8,21H1c-.55225,0-1-.44727-1-1v-7c0-.55273.44775-1,1-1h7c.55225,0,1,.44727,1,1v7c0,.55273-.44775,1-1,1Zm-6-2h5v-5H2v5Z",
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 12.5,
    width: 11,
    height: 2,
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 15.5,
    width: 11,
    height: 2,
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 18.5,
    width: 6,
    height: 2,
    fill: "current",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchView);
export default __webpack_public_path__ + "static/media/switch-view.7a919ae1e126d3fa6db6ebab573961d8.svg";
export { ForwardRef as ReactComponent };